export default __webpack_public_path__ + "cb0ab2e503e888d814577b62062a2b4d.png";